/**
 * @file: 画布区域交互逻辑初始化
 * @author: xiaolong.huang@dmall.com
 */

import Transform from './transform/index';
import Select from './select/index';
import Shortcutkey from './shortcutkey/index';
import Move from './move/index';
import CopySysTem from './copySystem/index';
import Contextmenu from './contextmenu/index';
import LayerGroup from './layerGroup/index';
import DrawRect from './drawRect/index';
import Refresh from './refresh/index';
import Save from './save/index';
import Drag from './drag/index';
import Api from './api';

function init(stageCube: CubeNode): void {
    // 快捷键初始化
    Shortcutkey.init();

    // 画布矩阵变换初始化
    Transform.init(stageCube);

    // 层板编组初始化
    LayerGroup.init();

    // 右键菜单初始化
    Contextmenu.init();

    // 拖拽交互
    Drag.init();

    // 框选矩形
    DrawRect.init();

    // 接口挂载
    Api.mount();
}

export default {
    init
}
